import { Switch } from "react-router-dom";
import FinanceiroPage from "./FinanceiroPage";
import DemonstrativoReceitasDespesas from "./DemonstrativoReceitasDespesas";
import RelatorioDespesa from "./RelatorioDespesa";
import AuthRoute from "components/AuthRoute";
import { PermissaoEnum } from "resources/enums/permissao";
import InadimplentesPage from "./Inadimplentes";
import RelatorioReceitasPage from "./RelatorioReceitas";
import DemonstrativoReceitasDespesasAnual from "./DemonstrativoReceitasDespesasAnual";
import RelatorioPrestacaoContasPage from "./RelatorioPrestacaoContas";
import BalancoFinanceiroPage from "./BalancoFinanceiro/index";
import RelatorioComposicaoReceitasPage from "./RelatorioComposicaoReceitas/index";
import RelatorioComposicaoReceitasHorizontalPage from "./RelatorioComposicaoReceitasHorizontal/index";
import RelatorioDespesasPorCategoriaPage from "./RelatorioDespesasPorCategoria/index";

function FinanceiroScreen() {
  return (
    <Switch>
      <AuthRoute
        exact
        path="/relatorios/financeiro"
        component={FinanceiroPage}
        permissions={[
          PermissaoEnum.Backoffice.Relatorios.Financeiro.toString(),
          PermissaoEnum.Backoffice.Relatorios.Financeiro
            .DemonstrativoReceitaDespesa,
          PermissaoEnum.Backoffice.Relatorios.Financeiro
            .DemonstrativoReceitaDespesaAnual,
          PermissaoEnum.Backoffice.Relatorios.Financeiro.TotalDespesas,
          PermissaoEnum.Backoffice.Relatorios.Financeiro.Inadimplentes,
          PermissaoEnum.Backoffice.Relatorios.Financeiro.Receitas,
          PermissaoEnum.Backoffice.Relatorios.Financeiro.BalancoFinanceiro,
          PermissaoEnum.Backoffice.Relatorios.Financeiro.ComposicaoReceitas,
          PermissaoEnum.Backoffice.Relatorios.Financeiro
            .ComposicaoReceitasHorizontal,
          PermissaoEnum.Backoffice.Relatorios.Financeiro.DespesasPorCategoria,
        ]}
      />

      <AuthRoute
        exact
        path="/relatorios/financeiro/receitas-despesas"
        component={DemonstrativoReceitasDespesas}
        permissions={[
          PermissaoEnum.Backoffice.Relatorios.Financeiro
            .DemonstrativoReceitaDespesa,
        ]}
      />

      <AuthRoute
        exact
        path="/relatorios/financeiro/receitas-despesas-anual"
        component={DemonstrativoReceitasDespesasAnual}
        permissions={[
          PermissaoEnum.Backoffice.Relatorios.Financeiro
            .DemonstrativoReceitaDespesaAnual,
        ]}
      />

      <AuthRoute
        exact
        path="/relatorios/financeiro/despesas"
        component={RelatorioDespesa}
        permissions={[
          PermissaoEnum.Backoffice.Relatorios.Financeiro.TotalDespesas,
        ]}
      />

      <AuthRoute
        exact
        path="/relatorios/financeiro/inadimplentes"
        component={InadimplentesPage}
        permissions={[
          PermissaoEnum.Backoffice.Relatorios.Financeiro.Inadimplentes,
        ]}
      />

      <AuthRoute
        exact
        path="/relatorios/financeiro/receitas"
        component={RelatorioReceitasPage}
        permissions={[PermissaoEnum.Backoffice.Relatorios.Financeiro.Receitas]}
      />

      <AuthRoute
        exact
        path="/relatorios/financeiro/composicao-receitas"
        component={RelatorioComposicaoReceitasPage}
        permissions={[
          PermissaoEnum.Backoffice.Relatorios.Financeiro.ComposicaoReceitas,
        ]}
      />

      <AuthRoute
        exact
        path="/relatorios/financeiro/composicao-despesas"
        component={RelatorioDespesasPorCategoriaPage}
        permissions={[
          PermissaoEnum.Backoffice.Relatorios.Financeiro.DespesasPorCategoria,
        ]}
      />

      <AuthRoute
        exact
        path="/relatorios/financeiro/composicao-receitas-horizontal"
        component={RelatorioComposicaoReceitasHorizontalPage}
        permissions={[
          PermissaoEnum.Backoffice.Relatorios.Financeiro
            .ComposicaoReceitasHorizontal,
        ]}
      />

      <AuthRoute
        exact
        path="/relatorios/financeiro/prestacao-de-contas"
        component={RelatorioPrestacaoContasPage}
        permissions={[
          PermissaoEnum.Backoffice.Relatorios.Financeiro.PrestacaoContas,
        ]}
      />

      <AuthRoute
        exact
        path="/relatorios/financeiro/balanco-financeiro"
        component={BalancoFinanceiroPage}
        permissions={[
          PermissaoEnum.Backoffice.Relatorios.Financeiro.BalancoFinanceiro,
        ]}
      />
    </Switch>
  );
}

export default FinanceiroScreen;
